import * as React from 'react';
import { SVGProps } from 'react';

const IconSelectSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m6.5 9 5.5 6 5.5-6h-11Z" />
  </svg>
);
export default IconSelectSizeM;
